import { useAuth0 } from "@auth0/auth0-react";
import { PublicClientApplication, EventType, type AuthenticationResult, type Configuration } from "@azure/msal-browser";
import { useSuspenseQuery } from "@tanstack/react-query";

import client from "api/client";
import { useSettings } from "features/start/fabric";


export const useQueryAuth0 = () => {
	const auth0 = useAuth0();

	return useSuspenseQuery({
		queryKey: ["auth0"],
		queryFn: async () => {
			const token = await auth0.getAccessTokenSilently();
			client.setAuthTokenProvider(() => token);
			return token;
		}
	});
};

export const useQueryMsal = () => {
	const settings = useSettings();
	return useSuspenseQuery({
		queryKey: ["msal"],
		queryFn: () => {
			const msalOptions = {
				auth: {
					clientId: settings.msal.appId,
					authority: `https://login.microsoftonline.com/${settings.msal.tenantId}`,
					redirectUri: `https://${location.host}`
				},
				cache: {
					cacheLocation: "localStorage"
				}
			} satisfies Configuration;

			const msal = new PublicClientApplication(msalOptions);
			msal.initialize()
				.then(async () => {
					const account = msal.getActiveAccount();
					if (!account && msal.getAllAccounts().length > 0) msal.setActiveAccount(msal.getAllAccounts()[0]);
					msal.enableAccountStorageEvents();
					msal.addEventCallback((event) => {
						const authenticationResult = event?.payload as AuthenticationResult;
						if (event.eventType === EventType.LOGIN_SUCCESS && authenticationResult?.account) {
							const account = authenticationResult?.account;
							msal?.setActiveAccount(account);
							window.location.reload();
						}
					});
					client.setAuthTokenProvider(async () => {
						const active = msal?.getActiveAccount() ?? msal?.getAllAccounts()[0];
						if (!active) return undefined;
						const token = await msal?.acquireTokenSilent({
							account: active,
							authority: `${settings.azureAd.instance}${settings.azureAd.tenantId}/v2.0`,
							scopes: [`${settings.azureAd.audience}/full_access`]
						});
						return token?.accessToken;
					});
				});
			return msal;
		}
	});
};